module.exports = __webpack_public_path__ + "img/BryantRose.0d238ac3.jpg";